"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import WedgeWireProfileDiagram from "@/components/diagrams/WedgeWireProfileDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
export default function FlatPanelScreensPage() {
  const {
    lang
  } = useLanguage();
  const pageData = pick(lang, COPY);
  return <SubPageLayout content={pageData.content} diagram={<DiagramSection id="flat-panel-structure-diagram" title={pageData.diagramTitle} lead={pageData.diagramLead} tone="muted">
          <div className="max-w-3xl mx-auto rounded-lg border border-border bg-card p-6 md:p-8">
            <WedgeWireProfileDiagram variant="flat" />
          </div>
        </DiagramSection>} />;
}